var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Foot-area"},[_c('div',{staticClass:"foot-top"},[_c('div',{staticClass:"tip"},[_vm._v("免费咨询电话")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"address-link dis_flex"},[_c('div',{staticClass:"address"},[_vm._v("地址：河南省许昌市襄城县紫云镇工业园区")]),_vm._v(" "),_c('div',{staticClass:"links dis_flex flex_wrap dis_jucont_end"},[_c('span',[_vm._v("友情链接：")]),_vm._v(" "),_vm._l((_vm.linkList),function(link){return _c('a',{key:link.id,attrs:{"href":link.url,"target":"_blank"}},[_vm._v(_vm._s(link.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"foot-center ewms dis_flex flex_wrap"},_vm._l(([
        {
          img: 'http://wxsmjphoto.wanjiejixie.com/web_img/001.png',
          name: '微信视频号'
        },
        {
          img: 'http://wxsmjphoto.wanjiejixie.com/web_img/002.png',
          name: '快手：面条机',
          tip: 'ID：1653631971'
        },
        {
          img: 'http://wxsmjphoto.wanjiejixie.com/web_img/004.png',
          name: '快手：馒头机',
          tip: 'ID：mantouji666'
        },
        {
          img: 'http://wxsmjphoto.wanjiejixie.com/web_img/003.png',
          name: '抖音：面条机',
          tip: 'ID：miantiaoji777'
        },
        {
          img: 'http://wxsmjphoto.wanjiejixie.com/web_img/005.png',
          name: '抖音：馒头机',
          tip: 'ID：mantouji666'
        }
      ]),function(item,index){return _c('div',{key:index,staticClass:"img"},[_c('img',{attrs:{"src":item.img}}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),(item.tip)?_c('div',{staticClass:"tip"},[_vm._v(_vm._s(item.tip))]):_vm._e()])}),0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('el-backtop',{attrs:{"bottom":100,"right":20}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"phone"},[_c('a',{attrs:{"href":"tel:4006771996"}},[_vm._v("400-677-1996")]),_vm._v(" "),_c('a',{attrs:{"href":"tel:17746996888"}},[_vm._v("17746996888")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"foot-bottom"},[_vm._v("\n    CORPYRIGHT © 万杰智能科技股份有限公司 All Rights Reserved.\n    "),_c('a',{attrs:{"href":"http://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("豫ICP备10008366号")]),_vm._v(" "),_c('div',{attrs:{"id":"tongji"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cf7438e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 